var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99933 2 2H10V4H2V18H16V12H18V18C18 18.55 17.804 19.021 17.412 19.413C17.02 19.805 16.5493 20.0007 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3623 9.75 13.087 9.75C12.8117 9.75 12.5827 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4877 2.43767 13.463 1.463C14.4383 0.488333 15.6173 0.000666667 17 0H22V5C22 6.38333 21.5123 7.56267 20.537 8.538C19.5617 9.51333 18.3827 10.0007 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.021 5.425 14.063 5.625C14.105 5.825 14.1673 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.06267 18.55 4.338C18.55 4.61333 18.45 4.85067 18.25 5.05L15.65 7.65C15.8667 7.75 16.0877 7.83333 16.313 7.9C16.5383 7.96667 16.7673 8 17 8Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.8aaeed74f45d97211cc608189f9fabb2.svg";
export { ForwardRef as ReactComponent };